/**
 * Карусель иконок в герое начальной / средней / старшей школы.
 * Та же логика, что kindergartenFeaturesSlider.js без data-native-scroll:
 * центрирование по одной фиче, клоны, свайп с порогом.
 */
(function() {
  "use strict";

  try {
    var featuresGrid = null;
    var containerFeatures = null;
    var currentFeatureIndex = 0;
    var isFeatureTransitioning = false;
    var isFeatureAnimating = false;
    var featureItemGap = 0;

    function getFeatureItemWidth() {
      return 104;
    }

    function getFeatureItemStep() {
      return getFeatureItemWidth() + featureItemGap;
    }

    function getFeatureTransitionDuration() {
      return "0.4s";
    }

    function getFeatureTransitionDurationMs() {
      return 400;
    }

    function getRealFeatureItems() {
      if (!featuresGrid) return [];
      var all = featuresGrid.querySelectorAll(".secondary-feature-item");
      return Array.prototype.filter.call(all, function(el) {
        return !el.classList.contains("secondary-feature-item-clone");
      });
    }

    function cloneFeatureItems() {
      if (!featuresGrid) return;
      var oldClones = featuresGrid.querySelectorAll(".secondary-feature-item-clone");
      oldClones.forEach(function(c) {
        c.remove();
      });
      if (window.innerWidth > 768) return;
      var realItems = getRealFeatureItems();
      if (realItems.length === 0) return;

      var fragBefore = document.createDocumentFragment();
      realItems.forEach(function(item) {
        var cl = item.cloneNode(true);
        cl.classList.add("secondary-feature-item-clone");
        fragBefore.appendChild(cl);
      });
      featuresGrid.insertBefore(fragBefore, realItems[0]);

      realItems.forEach(function(item) {
        var cl = item.cloneNode(true);
        cl.classList.add("secondary-feature-item-clone");
        featuresGrid.appendChild(cl);
      });
    }

    function getInitialFeatureTranslate() {
      if (!containerFeatures || !featuresGrid) return 0;
      var centerX = window.innerWidth / 2;
      var containerRect = containerFeatures.getBoundingClientRect();
      var containerLeft = containerRect.left;
      var itemWidth = getFeatureItemWidth();
      var itemStep = getFeatureItemStep();
      var realItems = getRealFeatureItems();
      var firstItemIndex = realItems.length;
      var firstItemLeft = firstItemIndex * itemStep;
      var firstItemCenter = firstItemLeft + itemWidth / 2;
      return centerX - containerLeft - firstItemCenter;
    }

    function updateFeaturesSlider() {
      if (!featuresGrid || !containerFeatures || window.innerWidth > 768) return;
      var realItems = getRealFeatureItems();
      if (realItems.length === 0) return;
      if (currentFeatureIndex < 0) currentFeatureIndex = 0;
      if (currentFeatureIndex >= realItems.length) {
        currentFeatureIndex = realItems.length - 1;
      }

      var centerX = window.innerWidth / 2;
      var containerRect = containerFeatures.getBoundingClientRect();
      var containerLeft = containerRect.left;
      var currentItemWidth = getFeatureItemWidth();
      var currentItemStep = getFeatureItemStep();
      var itemCenterX = currentItemWidth / 2;
      var realItemIndexInDOM = realItems.length + currentFeatureIndex;
      var activeItemLeftPosition = realItemIndexInDOM * currentItemStep;
      var activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
      var translateX = centerX - containerLeft - activeItemCenterPosition;

      if (!isFeatureTransitioning) {
        featuresGrid.style.transition =
          "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
      }
      featuresGrid.style.transform = "translateX(" + translateX + "px)";
    }

    function goToNextFeature() {
      if (isFeatureTransitioning || isFeatureAnimating || window.innerWidth > 768) return;
      var realItems = getRealFeatureItems();
      var realItemsCount = realItems.length;
      if (realItemsCount === 0) return;

      if (currentFeatureIndex < realItemsCount - 1) {
        isFeatureAnimating = true;
        currentFeatureIndex++;
        if (featuresGrid.style.transition === "none") {
          featuresGrid.style.transition =
            "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
        }
        updateFeaturesSlider();
        setTimeout(function() {
          isFeatureAnimating = false;
        }, getFeatureTransitionDurationMs());
      } else {
        if (isFeatureTransitioning || isFeatureAnimating) return;
        isFeatureTransitioning = true;
        isFeatureAnimating = true;
        var currentItemStep = getFeatureItemStep();
        var currentItemWidth = getFeatureItemWidth();
        var itemCenterX = currentItemWidth / 2;
        var firstCloneIndex = realItemsCount * 2;
        var activeItemLeftPosition = firstCloneIndex * currentItemStep;
        var activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
        var viewportCenter = window.innerWidth / 2;
        var cRect = containerFeatures.getBoundingClientRect();
        var translateX = viewportCenter - cRect.left - activeItemCenterPosition;
        featuresGrid.style.transition =
          "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
        featuresGrid.style.transform = "translateX(" + translateX + "px)";
        setTimeout(function() {
          featuresGrid.style.transition = "none";
          currentFeatureIndex = 0;
          updateFeaturesSlider();
          requestAnimationFrame(function() {
            setTimeout(function() {
              isFeatureTransitioning = false;
              isFeatureAnimating = false;
              featuresGrid.style.transition =
                "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
            }, 0.0001);
          });
        }, getFeatureTransitionDurationMs());
      }
    }

    function goToPrevFeature() {
      if (isFeatureTransitioning || isFeatureAnimating || window.innerWidth > 768) return;
      var realItems = getRealFeatureItems();
      var realItemsCount = realItems.length;
      if (realItemsCount === 0) return;

      if (currentFeatureIndex > 0) {
        isFeatureAnimating = true;
        currentFeatureIndex--;
        if (featuresGrid.style.transition === "none") {
          featuresGrid.style.transition =
            "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
        }
        updateFeaturesSlider();
        setTimeout(function() {
          isFeatureAnimating = false;
        }, getFeatureTransitionDurationMs());
      } else {
        if (isFeatureTransitioning || isFeatureAnimating) return;
        isFeatureTransitioning = true;
        isFeatureAnimating = true;
        var currentItemStep = getFeatureItemStep();
        var currentItemWidth = getFeatureItemWidth();
        var itemCenterX = currentItemWidth / 2;
        var lastCloneIndex = realItemsCount - 1;
        var activeItemLeftPosition = lastCloneIndex * currentItemStep;
        var activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
        var viewportCenter = window.innerWidth / 2;
        var cRect = containerFeatures.getBoundingClientRect();
        var translateX = viewportCenter - cRect.left - activeItemCenterPosition;
        featuresGrid.style.transition =
          "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
        featuresGrid.style.transform = "translateX(" + translateX + "px)";
        setTimeout(function() {
          featuresGrid.style.transition = "none";
          currentFeatureIndex = realItemsCount - 1;
          updateFeaturesSlider();
          requestAnimationFrame(function() {
            setTimeout(function() {
              isFeatureTransitioning = false;
              isFeatureAnimating = false;
              featuresGrid.style.transition =
                "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
            }, 0.0001);
          });
        }, getFeatureTransitionDurationMs());
      }
    }

    function cleanupDesktop() {
      if (!featuresGrid) return;
      featuresGrid.querySelectorAll(".secondary-feature-item-clone").forEach(function(c) {
        c.remove();
      });
      featuresGrid.style.transform = "";
      featuresGrid.style.transition = "";
      featuresGrid.classList.remove("dragging");
      featuresGrid.removeAttribute("data-secondary-hero-features-bound");
    }

    function initFeaturesSlider() {
      containerFeatures = document.querySelector(".secondary-hero-features-container");
      featuresGrid = document.querySelector(".secondary-hero-features");

      if (window.innerWidth > 768) {
        cleanupDesktop();
        return;
      }

      if (!containerFeatures || !featuresGrid) return;

      var realItems = getRealFeatureItems();
      if (realItems.length === 0) return;

      /* Повторный вызов (resize): не сбрасываем currentFeatureIndex — иначе при скролле страницы
         (сворачивание адресной строки → resize) карусель прыгала на первый слайд */
      if (featuresGrid.getAttribute("data-secondary-hero-features-bound") === "1") {
        cloneFeatureItems();
        featuresGrid.style.transition = "none";
        updateFeaturesSlider();
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (featuresGrid) {
              featuresGrid.style.transition =
                "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
            }
          });
        });
        return;
      }

      featuresGrid.setAttribute("data-secondary-hero-features-bound", "1");

      cloneFeatureItems();
      currentFeatureIndex = 0;
      featuresGrid.style.transition = "none";
      featuresGrid.style.transform = "translateX(" + getInitialFeatureTranslate() + "px)";
      setTimeout(function() {
        featuresGrid.style.transition =
          "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
        updateFeaturesSlider();
      }, 50);

      var isDragging = false;
      var startX = 0;
      var currentX = 0;
      var initialTranslate = 0;

      featuresGrid.addEventListener("mousedown", function(e) {
        if (isFeatureTransitioning || isFeatureAnimating || window.innerWidth > 768) return;
        isDragging = true;
        startX = e.clientX;
        var m = (featuresGrid.style.transform || "").match(/translateX\(([^)]+)\)/);
        initialTranslate = m ? parseFloat(m[1]) : getInitialFeatureTranslate();
        featuresGrid.classList.add("dragging");
        e.preventDefault();
      });

      featuresGrid.addEventListener("mousemove", function(e) {
        if (!isDragging) return;
        currentX = e.clientX - startX;
        featuresGrid.style.transform = "translateX(" + (initialTranslate + currentX) + "px)";
      });

      featuresGrid.addEventListener("mouseup", function() {
        if (!isDragging) return;
        isDragging = false;
        featuresGrid.classList.remove("dragging");
        var threshold = getFeatureItemStep() / 6;
        if (Math.abs(currentX) > threshold) {
          if (currentX > 0) goToPrevFeature();
          else goToNextFeature();
        } else {
          updateFeaturesSlider();
        }
        currentX = 0;
      });

      featuresGrid.addEventListener("mouseleave", function() {
        if (isDragging) {
          isDragging = false;
          featuresGrid.classList.remove("dragging");
          updateFeaturesSlider();
          currentX = 0;
        }
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var touchCurrentX = 0;
      var touchInitialTranslate = 0;

      featuresGrid.addEventListener(
        "touchstart",
        function(e) {
          if (isFeatureTransitioning || isFeatureAnimating || window.innerWidth > 768) return;
          isDragging = true;
          touchCurrentX = 0;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          var m = (featuresGrid.style.transform || "").match(/translateX\(([^)]+)\)/);
          touchInitialTranslate = m ? parseFloat(m[1]) : getInitialFeatureTranslate();
          featuresGrid.classList.add("dragging");
        },
        { passive: true }
      );

      /* Как kindergartenAdvantagesSlider / schoolAdvantagesSlider: transform на каждом move, preventDefault только при явном горизонтальном жесте */
      featuresGrid.addEventListener(
        "touchmove",
        function(e) {
          if (!isDragging) return;
          var dx = e.touches[0].clientX - touchStartX;
          var dy = e.touches[0].clientY - touchStartY;
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5 && e.cancelable) {
            e.preventDefault();
          }
          if (window.innerWidth <= 768) {
            touchCurrentX = dx;
            featuresGrid.style.transform =
              "translateX(" + (touchInitialTranslate + touchCurrentX) + "px)";
          }
        },
        { passive: false }
      );

      featuresGrid.addEventListener(
        "touchend",
        function() {
          if (!isDragging) return;
          isDragging = false;
          featuresGrid.classList.remove("dragging");
          var threshold = getFeatureItemStep() / 6;
          if (Math.abs(touchCurrentX) > threshold) {
            if (touchCurrentX > 0) goToPrevFeature();
            else goToNextFeature();
          } else {
            updateFeaturesSlider();
          }
          touchCurrentX = 0;
        },
        { passive: true }
      );

      featuresGrid.addEventListener(
        "touchcancel",
        function() {
          if (!isDragging) return;
          isDragging = false;
          featuresGrid.classList.remove("dragging");
          updateFeaturesSlider();
          touchCurrentX = 0;
        },
        { passive: true }
      );
    }

    var resizeT;
    var lastHeroResizeWidth = null;

    function onResize() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function() {
        var w = window.innerWidth;
        if (
          lastHeroResizeWidth !== null &&
          w === lastHeroResizeWidth &&
          w <= 768
        ) {
          containerFeatures = document.querySelector(".secondary-hero-features-container");
          featuresGrid = document.querySelector(".secondary-hero-features");
          if (
            featuresGrid &&
            featuresGrid.getAttribute("data-secondary-hero-features-bound") === "1" &&
            containerFeatures
          ) {
            featuresGrid.style.transition = "none";
            updateFeaturesSlider();
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                if (featuresGrid) {
                  featuresGrid.style.transition =
                    "transform " + getFeatureTransitionDuration() + " cubic-bezier(0.4, 0, 0.2, 1)";
                }
              });
            });
          }
          return;
        }
        lastHeroResizeWidth = w;
        initFeaturesSlider();
      }, 120);
    }

    function boot() {
      lastHeroResizeWidth = window.innerWidth;
      initFeaturesSlider();
      window.addEventListener("resize", onResize);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  } catch (e) {}
})();
